import React, { useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../buttons/buttons";
import Input from "../../inputs/inputs";
import { Beat } from "../../../plugins/spinners.plugin";
import {
  updateAnInfractionAction,
  getAnInfractionAction,
} from "../../../redux/infraction/infractionActions";

export default function UpdateInfractionModalModal(props) {
  const { id } = props;
  const dispatch = useDispatch();
  const { updating, singleInfraction } = useSelector(
    (state) => state.infraction
  );

  const [data, setData] = useState({
    id: id,
    type: "",
  });

  useEffect(() => {
    if (singleInfraction) {
      setData((data) => ({ ...data, type: singleInfraction.type }));
    }
  }, [singleInfraction]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleUpdateData = async () => {
    try {
      const response = await dispatch(updateAnInfractionAction(data));
      if (response) {
        props.onClose();
        dispatch(getAnInfractionAction(id));
      }
    } catch (error) {}
  };

  return (
    <div data-test="infractionModal">
      <Transition appear show={props.show}>
        <Dialog as="div" className="relative z-10" onClose={props.onClose}>
          <Transition.Child
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="bg-white dark:bg-[#121212] w-full text-left sm:w-[450px] p-4 sm:p-6">
                  <div className="pb-5 text-center sm:mt-2 sm:text-center border-b border-[#E4E4F3]">
                    <Dialog.Title
                      as="h3"
                      className="text-lg text-black dark:text-white"
                    >
                      Update Request Type
                    </Dialog.Title>
                  </div>

                  <>
                    <div className="mx-auto py-8">
                      <div className="mb-4">
                        <Input.Select
                          title={"Request Type"}
                          htmlFor={"type"}
                          name={"type"}
                          value={data?.type}
                          onChange={handleChange}
                        >
                          <option>Select Request Type</option>
                          <option value={"warning issued"}>
                            Warning Issued
                          </option>
                          <option value={"action taken"}>Action Taken</option>
                        </Input.Select>
                      </div>
                    </div>

                    <div className="flex justify-between gap-8">
                      <Button.Secondary
                        title={"Cancel"}
                        className="w-full"
                        onClick={props.onClose}
                      />
                      <Button.Primary
                        title={updating ? <Beat color={"#ffffff"} /> : "Update"}
                        type={"button"}
                        className="w-full"
                        onClick={handleUpdateData}
                      />
                    </div>
                  </>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
